export enum CreateCompanyEvent {
  OnViewInit = 'createCompanyOnViewInit',
}
